var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.6875,
    y: 19.6245,
    width: 2.74996,
    height: 12.3748,
    rx: 1.37498,
    fill: "#DBF0F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8125,
    y: 25.1245,
    width: 2.74996,
    height: 6.87491,
    rx: 1.37498,
    fill: "#DBF0F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5645,
    y: 15.4995,
    width: 2.74996,
    height: 16.4998,
    rx: 1.37498,
    fill: "#DBF0F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.4375,
    y: 10,
    width: 2.74996,
    height: 21.9997,
    rx: 1.37498,
    fill: "#DBF0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.0d95e552f3e76f27dbc2230269f09653.svg";
export { ForwardRef as ReactComponent };